import { render } from "./AllUsersRankingModal.vue?vue&type=template&id=168a0924&scoped=true"
import script from "./AllUsersRankingModal.vue?vue&type=script&lang=js"
export * from "./AllUsersRankingModal.vue?vue&type=script&lang=js"

import "./AllUsersRankingModal.vue?vue&type=style&index=0&id=168a0924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168a0924"]])

export default __exports__